export default __webpack_public_path__ + "static/media/gooseberry-icon.ed9f3352.svg";